// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { bucketCardsStyles } from "@steiner/App/Widgets/BucketCards/BucketCards";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

bucketCardsStyles.container = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 32px 22px;
        padding: 0 16px 32px;
        background: linear-gradient(transparent 32px, #eeeeee 32px);

        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

bucketCardsStyles.wrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
};

bucketCardsStyles.image = {
    width: "124px",
    height: "124px",
    css: css`
        img {
            aspect-ratio: 1 / 1;
        }
    `,
};

bucketCardsStyles.title = {
    variant: "h3",
    color: "common.ui16",
    css: css`
        margin: 16px 0 12px;
    `,
};

bucketCardsStyles.description = {
    size: 16,
    lineHeight: "24px",
    color: "common.ui6",
    css: css`
        text-align: center;
        ${TypographyStyle} {
            margin: 0;
        }
    `,
};
